import { useCssVars as _useCssVars, defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, withCtx as _withCtx, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, vModelCheckbox as _vModelCheckbox, withDirectives as _withDirectives, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "virtualized-inventory-table-container" }
const _hoisted_2 = ["checked"]
const _hoisted_3 = { class: "table-header__grid" }
const _hoisted_4 = { class: "table-header__data-label" }
const _hoisted_5 = { class: "table-cell--bold" }
const _hoisted_6 = { class: "table-row--child" }
const _hoisted_7 = { class: "table-row--error__container" }
const _hoisted_8 = { class: "table-row--error__message" }
const _hoisted_9 = ["onClick"]
const _hoisted_10 = { class: "grid-container table-checkbox" }
const _hoisted_11 = { key: 0 }
const _hoisted_12 = ["value"]
const _hoisted_13 = { key: 1 }
const _hoisted_14 = ["id", "onClick"]
const _hoisted_15 = ["for"]

import { computed, ref, toRef, markRaw, onUnmounted } from 'vue';
import { storeToRefs } from 'pinia';
import { i18n } from '@/i18n';
import { useInventoryStore } from '../../pages/useInventoryStore/';
import { InventoryTableViewModel } from '../../pages/inventoryTableViewModel';
import { DateService } from '@/coreDomainsModule/services/dateService';
import { OrderRepository } from '@/coreInfrastructureModule/Repositories/OrderRepository';
import SvgLoader from '@/utils/SvgLoader.vue';
import TextButton from '@/components/input/Btn/TextButton.vue';
import TableMemoButton from '@/corePagesModule/tableMemoButton/TableMemoButton.vue';
import ArrowIcon from '@/corePagesModule/BaseTableContent/components/ArrowIcon.vue';
import {
  MAX_COLUMN_WIDTH,
  MIN_COLUMN_WIDTH,
  DETAIL_BUTTON_COLUMN_WIDTH,
  HEADER_MODIFY_BUTTON_COLUMN_WIDTH,
} from '@/corePagesModule/BaseTableContent/constants';
import { VIRTUAL_SCROLL, ORDER_MODE_TABLE_CONTENT_ID, ORDER_HEADER_COLUMN_DEFAULT_NUMBER } from '../../constants';
import { getMonthFromHeaderKey } from '../../utils/tableHelpers';
import { IParentBusiness } from '../../domains/entities/Business';
import { ArrivalStatus } from '@/coreDomainsModule/entities/arrival';
import { isLoading, isZeroMatch } from '@/coreDomainsModule/uiLoadingState';
import { InventoryTableService } from '../../domains/services/inventoryTableService';
import { diContainer } from '@/coreContainer/container';
import VirtualizedEzTable from '@/corePagesModule/components/ezTable/VirtualizedEzTable.vue';
import EzHeader from '@/corePagesModule/components/ezTable/EzHeader.vue';
import EzCell from '@/corePagesModule/components/ezTable/EzCell.vue';
import EzTableLoadingState from '@/corePagesModule/components/ezTable/EzTableLoadingState.vue';
import EzTableErrorState from '@/corePagesModule/components/ezTable/EzTableErrorState.vue';
import EzTableZeroMatchState from '@/corePagesModule/components/ezTable/EzTableZeroMatchState.vue';
import { useColumnResizer } from '@/corePagesModule/composables/useColumnResizer';
import { useTableHeader } from '@/corePagesModule/composables/useTableHeader';
import { useTableMemo } from '../../composables/useTableMemo';
import { LoadingStatus } from '@/corePagesModule/components/ezTable/types';
import { useTableCalculation } from '@/InventoryControlModule/composables/useTableCalculation';
import { useOrderCalculation } from '@/InventoryControlModule/composables/useOrderCalculation';
import { TableCommonViewModel } from '@/viewModels/tableContent';
import TableHeaderModifyButton from '@/corePagesModule/components/TableHeaderModifyButton.vue';
import { useTableState } from '../../composables/useTableState';
import OrderMonthlyColumn from './OrderMonthlyColumn.vue';
import TransactionSummaryColumn from './TransactionSummaryColumn.vue';
import EditableForecastAccuracyCell from '../ForecastAccuracy/EditableForecastAccuracyCell.vue';
import ForecastAccuracyHistoryModal from '../ForecastAccuracy/ForecastAccuracyHistoryModal.vue';
import BusinessRowMenu from './BusinessRowMenu.vue';
import CombineOrderModal from '../CombineOrder/CombineOrderModal.vue';
import CombineOrderConfirmModal from '../CombineOrder/CombineOrderConfirmModal.vue';

/**
 * InventoryOrderTableコンポーネントのプロパティ
 * @param tableContainerWidth - テーブルコンテナの幅
 * @param tableContainerHeight - テーブルコンテナの高さ
 * @param isEllipsis - テキスト省略有無
 * @param mouseoverTextLabel - マウスオーバー時のテキストラベル処理関数
 */
interface InventoryOrderTableProps {
  tableContainerWidth: number;
  tableContainerHeight: number;
  isEllipsis: boolean;
  transactionMonths: number[];
  mouseoverTextLabel: (e: MouseEvent) => void;
}
type FullHeader = {
  key: string;
  label: string;
  width: string;
  sticky: boolean;
  resizable?: boolean;
};

interface VirtualItem {
  type: 'loading' | 'error' | 'zeroMatch' | 'parent' | 'child';
  data?: IParentBusiness;
  parentId?: string;
}

/**
 * セルがハイライトされているかどうかを判定する
 * @param virtualItem - 仮想アイテム
 * @returns ハイライト状態
 */

export default /*@__PURE__*/_defineComponent({
  __name: 'VirtualizedEzOrderTable',
  props: {
    tableContainerWidth: {},
    tableContainerHeight: {},
    isEllipsis: { type: Boolean },
    transactionMonths: {},
    mouseoverTextLabel: { type: Function }
  },
  setup(__props: any, { expose: __expose }) {

_useCssVars(_ctx => ({
  "69418ca0": (`${_unref(MAX_COLUMN_WIDTH)}px`),
  "ea011afc": (`${_unref(MIN_COLUMN_WIDTH)}px`),
  "dda38bd6": (`1 / ${_unref(ORDER_HEADER_COLUMN_DEFAULT_NUMBER) - _unref(getHiddenHeaderNumber)(fullHeaders.value.map(v => v.key), _unref(state).hiddenTransactionHeaderList) + 1}`)
}))

const props = __props;

// Store
const inventoryStore = useInventoryStore();
const { state } = storeToRefs(inventoryStore);
const {
  changeHeaderSorting,
  toggleOpenBusinesses,
  onCheckedAllRows,
  confirmOrderEdit,
  updateForecastAccuracySettingAccuracy,
  openForecastAccuracyHistoryModal,
  closeForecastAccuracyHistoryModal,
  changeForecastAccuracyHistoryPeriod,
  setBusinessRowMenuStateAndProcessing,
  getHiddenTransactionHeader,
} = inventoryStore;

const { getHiddenHeaderNumber, getMonthlyData } = useTableCalculation();

// 発注計算のComposable
const {
  calculateOrderModeExceptedEndInventory: calcOrderExceptedEnd,
  calculateOrderModeTurnOver: calcOrderTurnOver,
  getMonthFromHeaderKey: getMonthFromKey,
  ensureOrderEditData: ensureOrderData,
} = useOrderCalculation();

// Memo機能のComposable
const { saveAggregateMemo, deleteAggregateMemo, saveChildMemo, deleteChildMemo } = useTableMemo();

// テーブル状態管理のComposable
const {
  tableTextStyleClass,
  tableNumberStyleClass,
  getNowInventoryStatusClass,
  isNegative,
  handleToggle: baseHandleToggle,
  createScrollHandler,
} = useTableState();

// i18n
const t = i18n.t;

// ViewModels
const vm = markRaw(new TableCommonViewModel());
const inventoryVm = markRaw(new InventoryTableViewModel());

// 仮想スクロール設定
const ITEM_HEIGHT = VIRTUAL_SCROLL.ITEM_HEIGHT;
const BUFFER_SIZE = VIRTUAL_SCROLL.BUFFER_SIZE;

/**
 * 動的に計算されるコンテナ高さ（propsから取得）
 */
const containerHeight = computed(() => props.tableContainerHeight || 1000);

// 処理負荷軽減のためのキャッシュマップ
const styleClassCache = new Map<string, string>();
const headerDisplayCache = new Map<string, string>();
const executionDateCache = new Map<string, string>();

/**
 * テーブルのヘッダ（チェックボックス列を含む完全版）
 */
const defaultFullHeaderKeys = computed(() => {
  const exceptHeaders = new Set(['choice', 'Arrivals', 'orderConfirmation', 'headerModify']);
  const returnHeaders: string[] = [
    'checkbox',
    'orderDetail',
    ...vm.displayHeaders.inventoryControl.filter((key) => !exceptHeaders.has(key)),
  ];

  // 月次データヘッダー（一度だけ計算）
  const monthlyHeaders = props.transactionMonths.flatMap((month) =>
    inventoryVm.getMonthlyTransactionHeaderKeys(month, true).map((arrivalKey) => `transaction-${month}-${arrivalKey}`)
  );

  returnHeaders.push(...monthlyHeaders, 'headerModify');
  return returnHeaders;
});

const { headerList, updateDisplayHeader } = useTableHeader(
  defaultFullHeaderKeys,
  'inventoryControlWithOrder',
  inventoryVm.DEFAULT_HIDDEN_HEADER_KEYS
);

/**
 * 完全なヘッダー定義を生成する（チェックボックス列・基本ヘッダー・月次データ列・発注詳細・ヘッダー追加を含む）
 * @returns FullHeader[]
 */
const fullHeaders = computed(() => {
  console.log(headerList.value);

  const returnHeaders: FullHeader[] = [];
  // チェックボックス列
  returnHeaders.push(
    {
      key: 'checkbox',
      label: '',
      width: '50px',
      sticky: true,
      resizable: false,
    },
    {
      key: 'orderDetail',
      label: t('詳細'),
      width: `${DETAIL_BUTTON_COLUMN_WIDTH}px`,
      sticky: true,
      resizable: false,
    }
  );

  const exceptHeader = ['choice', 'Arrivals', 'orderConfirmation', 'headerModify'];

  const baseHeader = vm.displayHeaders.inventoryControl.filter(
    (key) => !exceptHeader.includes(key) && (headerList.value.length > 0 ? headerList.value.includes(key) : true)
  );

  // 基本ヘッダー
  for (const header of baseHeader) {
    const label = inventoryVm.getDisplayHeaderName(header);
    if (label === '') continue;
    returnHeaders.push({
      key: header,
      label,
      width: `${state.value.tableInfos[header] || MIN_COLUMN_WIDTH}px`,
      sticky: true,
      resizable: true,
    });
  }

  // 月次データヘッダー（編集カラムも含める）
  for (const month of props.transactionMonths) {
    for (const arrivalKey of inventoryVm.getMonthlyTransactionHeaderKeys(month, true)) {
      const key = `transaction-${month}-${arrivalKey}`;
      if (!headerList.value.includes(key)) continue;
      const labelMonth =
        arrivalKey !== 'nowInventory' &&
        arrivalKey !== 'previousMonthAccuracy' &&
        arrivalKey !== 'settingAccuracy' &&
        arrivalKey !== 'accuracyHistory'
          ? t(DateService.getFormattedMonth(month)) + '\n'
          : '';
      returnHeaders.push({
        key,
        label: `${labelMonth}${inventoryVm.getTransactionHeaderNameForOrderMode(arrivalKey)}`,
        width: `${state.value.tableInfos[key] || MIN_COLUMN_WIDTH}px`,
        sticky: false,
        resizable: arrivalKey !== 'alert',
      });
    }
  }

  // ヘッダー追加列
  returnHeaders.push({
    key: 'headerModify',
    label: t('ヘッダー追加'),
    width: `${HEADER_MODIFY_BUTTON_COLUMN_WIDTH}px`,
    sticky: false,
    resizable: false,
  });
  return returnHeaders;
});

const getModifiableHeaderList = computed(() => {
  return defaultFullHeaderKeys.value
    .filter((key) => !['checkbox', 'orderDetail', 'headerModify'].includes(key))
    .map((key) => {
      if (vm.displayHeaders.inventoryControl.includes(key)) {
        return { key: key, text: inventoryVm.getDisplayHeaderName(key), isShown: headerList.value.includes(key) };
      }
      const splitKey = key.split('-');
      const arrivalKey = splitKey.at(-1);
      const arrivalMonth = getMonthFromKey(key);
      if (!splitKey || !arrivalKey) return { key: key, text: 'ERROR', isShown: headerList.value.includes(key) };
      const labelText = inventoryVm.getTransactionHeaderNameForOrderMode(arrivalKey);
      const labelMonth =
        arrivalKey !== 'nowInventory' &&
        arrivalKey !== 'previousMonthAccuracy' &&
        arrivalKey !== 'settingAccuracy' &&
        arrivalKey !== 'accuracyHistory'
          ? t(DateService.getFormattedMonth(arrivalMonth)) + '\n'
          : '';
      return {
        key: key,
        text: `${labelMonth}${labelText}`,
        isShown: headerList.value.includes(key),
      };
    });
});

/**
 * 後方互換性のためのheaders（既存コードとの互換性を保つ）
 */
const headers = computed(() => {
  return fullHeaders.value.slice(1); // チェックボックス列を除く
});

/**
 * グリッドテンプレート列の配列を生成する
 */
const gridTemplateColumns = computed(() => {
  // fullHeadersのwidthのみを使う
  return fullHeaders.value.map((header) => header.width);
});

/**
 * 固定する列のインデックス配列を生成する
 */
const stickyColumnIndexes = computed(() => {
  return fullHeaders.value.map((header, index) => (header.sticky ? index : -1)).filter((index) => index !== -1);
});

/**
 * 展開されたアイテムのセット
 */
const expandedItems = computed(() => {
  const expanded = new Set<string>();
  if (state.value.isOpeningBusinessId) {
    expanded.add(state.value.isOpeningBusinessId);
  }
  return expanded;
});

/**
 * 子アイテムを取得する関数
 * @param item - 親ビジネスアイテム
 * @returns 子アイテムの配列
 */
const getChildItems = (item: IParentBusiness) => {
  return item.children || [];
};

/**
 * 列の左位置を正確に計算する
 * @param columnIndex - 計算対象の列インデックス
 * @returns 左位置のピクセル値（例: '50px'）
 */
const getLeftPosition = (columnIndex: number): string => {
  let leftPos = 0;
  for (let i = 0; i < columnIndex; i++) {
    if (fullHeaders.value[i] && fullHeaders.value[i].sticky) {
      const width = parseInt(fullHeaders.value[i].width.replace('px', ''), 10) || 0;
      leftPos += width;
    }
  }
  return `${leftPos}px`;
};

/**
 * 仮想スクロールのスクロールハンドラ
 * @param scrollTop - スクロール位置
 */
const handleScroll = (scrollTop: number) => {
  // オーダーテーブル特有の処理があれば追加
};

/**
 * VirtualizedEzTable用のtoggleハンドララッパー
 * @param itemId - 展開対象のID
 */
const handleToggleOpenBusinesses = async (itemId: string) => {
  await toggleOpenBusinesses(itemId);
};

// テーブル要素のrefを宣言
const tableEl = ref<HTMLElement | null>(null);

// =====================
// ヘッダー編集機能の追加
// =====================

// setupMoveWarehouse, safeConvertIDateToDateをグローバル関数として定義

/**
 * 置き場移動セットアップ
 * @param inventoryRepository - 在庫リポジトリ（使用されませんが、既存のAPIとの互換性のため保持）
 * @param business - ビジネス情報
 * @param targetYearMonth - 対象年月
 */
function setupMoveWarehouse(inventoryRepository: any, business: any, targetYearMonth: any) {
  return inventoryStore.setupMoveWarehouse(diContainer.inventoryRepository, business, targetYearMonth);
}

/**
 * 対象の親ビジネス（IParentBusiness）をbusinessListから取得する
 * @param businessId - 取引ID
 * @returns IParentBusiness | undefined
 */
function findParentBusinessById(businessId: string): IParentBusiness | undefined {
  return state.value.businessList.find((b) => b.businessId === businessId);
}

/**
 * 現在のテーブルローディング状態をEzTable用の型に変換
 */
const currentLoadingStatus = computed((): LoadingStatus => {
  const tableStatus = state.value.tableLoadingState.status;

  if (isLoading(tableStatus) || headerList.value.length === 0) {
    return { type: 'loading' };
  }

  if (tableStatus.type === 'error') {
    return {
      type: 'error',
      errorMessage: tableStatus.errorMessage || t('データの取得に失敗しました。再度お試しください。'),
    };
  }

  if (isZeroMatch(tableStatus) && state.value.businessList.length === 0) {
    return { type: 'zero-match' };
  }

  return { type: 'success' };
});

/**
 * 月別の最後のヘッダーキー
 */
const getMonthlyEndHeader = computed(() => {
  return props.transactionMonths.reduce((acc, month) => {
    acc[month] = inventoryVm
      .getMonthlyTransactionHeaderKeys(month, true)
      .filter((key) => !state.value.hiddenTransactionHeaderList.includes(`transaction-${month}-${key}`))
      .at(-1);
    return acc;
  }, {});
});

/**
 * ヘッダーキーがある月の最後のヘッダーと一致しているか(=ヘッダーの右にボーダーが出るか)を返す関数
 * @param headerKey - ヘッダーキー
 */
const hasHeaderRightBorder = (headerKey: string) => {
  return props.transactionMonths.some((month) => headerKey === `transaction-${month}-${getMonthlyEndHeader.value[month]}`);
};

const { onMousedownResizer } = useColumnResizer({
  tableType: 'inventoryControlWithOrder',
  keys: fullHeaders.value.map((header) => header.key),
  widthInfo: toRef(state.value, 'tableInfos'),
  tableEl, // 追加: テーブル要素のrefを渡す
});

/**
 * 子取引をリロードする(エラー時)
 * @param id - 親取引ID
 */
const reloadChildBusiness = async (id?: string) => {
  if (!id) return;
  await inventoryStore.fetchChildBusinesses(id);
};

/**
 * 仮想アイテムの型定義
 */
const isCellHighlighted = (virtualItem: VirtualItem): boolean => {
  return (
    virtualItem.type === 'child' || // 子取引行
    virtualItem.type === 'loading' || // 子取引のロード行
    (state.value.isOpeningBusinessId === virtualItem.data?.businessId &&
      (virtualItem.data?.childrenAsyncStatus === 'loading' || virtualItem.data?.childrenAsyncStatus === 'loaded')) || // 展開中の親取引
    (virtualItem.data?.businessId ? state.value.checkedAggregateBusinessIds.includes(virtualItem.data.businessId) : false) || // チェックボックスが選択されている親取引
    (virtualItem.parentId ? state.value.checkedAggregateBusinessIds.includes(virtualItem.parentId) : false) // チェックボックスが選択されている子取引
  );
};

/**
 * 固定する列のleft値を算出する
 * @param headerIndex - 当該列のヘッダー番号
 */
const calcLeftNumber = (headerIndex: number) => {
  if (!fullHeaders.value[headerIndex].sticky) return 0;
  return stickyColumnIndexes.value
    .filter((index) => index < headerIndex)
    .reduce((acc, index) => {
      const currentWidth = parseFloat(fullHeaders.value[index].width);
      return acc + (isNaN(currentWidth) ? 0 : currentWidth);
    }, 0);
};

/**
 * ヘッダーの表示状態を更新する関数
 * ヘッダーの表示状態を更新し、state.value.hiddenTransactionHeaderListを更新する
 * @param key - ヘッダーキー
 * @param isHide - ヘッダーを非表示にするかどうか
 */
const updateTableHeaderData = async (key: string, isHide: boolean): Promise<void> => {
  // ヘッダーの表示状態を更新
  await updateDisplayHeader(key, isHide);
  // 非表示のトランザクションヘッダーリストを更新
  await getHiddenTransactionHeader();
};

__expose({
  state,
  t,
  changeHeaderSorting,
  handleScroll,
  toggleOpenBusinesses,
  onCheckedAllRows,
  diContainer,
  headers,
  getLeftPosition,
  InventoryTableService,
  getHiddenHeaderNumber,
});

/**
 * コンポーネントのクリーンアップ処理
 * メモリリークを防ぐためにキャッシュをクリア
 */
onUnmounted(() => {
  styleClassCache.clear();
  headerDisplayCache.clear();
  executionDateCache.clear();
});

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      ref_key: "tableEl",
      ref: tableEl,
      class: "inventory-virtual-table"
    }, [
      _createVNode(VirtualizedEzTable, {
        id: _unref(ORDER_MODE_TABLE_CONTENT_ID),
        items: _unref(state).businessList,
        "item-height": _unref(ITEM_HEIGHT),
        "container-height": containerHeight.value,
        "buffer-size": _unref(BUFFER_SIZE),
        "grid-template-columns": gridTemplateColumns.value,
        "sticky-column-indexes": stickyColumnIndexes.value,
        "loading-status": currentLoadingStatus.value,
        "expanded-items": expandedItems.value,
        "get-child-items": getChildItems,
        onToggle: handleToggleOpenBusinesses,
        onScroll: handleScroll
      }, {
        header: _withCtx(() => [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(fullHeaders.value, (header, index) => {
            return (_openBlock(), _createElementBlock(_Fragment, {
              key: header.key
            }, [
              (header.key === 'checkbox')
                ? (_openBlock(), _createBlock(EzHeader, {
                    key: 0,
                    sticky: "",
                    "sticky-offset": 0
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("input", {
                        type: "checkbox",
                        checked: _unref(state).isCheckAllRows,
                        onChange: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_unref(onCheckedAllRows) && _unref(onCheckedAllRows)(...args)))
                      }, null, 40, _hoisted_2)
                    ], undefined, true),
                    _: 1
                  }))
                : (header.key === 'headerModify')
                  ? (_openBlock(), _createBlock(EzHeader, {
                      key: 1,
                      sticky: "right"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(TableHeaderModifyButton, {
                          "modifiable-header-list": getModifiableHeaderList.value,
                          onToggle: updateTableHeaderData
                        }, null, 8, ["modifiable-header-list"])
                      ], undefined, true),
                      _: 1
                    }))
                  : (_openBlock(), _createBlock(EzHeader, {
                      key: 2,
                      sticky: header.sticky,
                      "sticky-offset": calcLeftNumber(index),
                      "use-resizer": header.resizable,
                      "sticky-left": header.sticky,
                      "sticky-left-position": getLeftPosition(index),
                      "column-index": index,
                      "has-right-border": hasHeaderRightBorder(header.key),
                      class: "table-header__data",
                      onClick: ($event: any) => (_unref(changeHeaderSorting)(header.key)),
                      onResizer: 
                (e) => {
                  _unref(onMousedownResizer)(e, header.key);
                }
              
                    }, {
                      default: _withCtx(() => [
                        _createElementVNode("div", _hoisted_3, [
                          _createElementVNode("span", _hoisted_4, _toDisplayString(header.label), 1),
                          (_unref(InventoryTableService).isHeaderKeySortable(header.key))
                            ? (_openBlock(), _createBlock(ArrowIcon, {
                                key: 0,
                                asc: header.key === _unref(state).headerSortingState.key ? _unref(state).headerSortingState.isAsc : true,
                                onOnClick: ($event: any) => (_unref(changeHeaderSorting)(header.key))
                              }, null, 8, ["asc", "onOnClick"]))
                            : _createCommentVNode("", true)
                        ])
                      ], undefined, true),
                      _: 2
                    }, 1032, ["sticky", "sticky-offset", "use-resizer", "sticky-left", "sticky-left-position", "column-index", "has-right-border", "onClick", "onResizer"]))
            ], 64))
          }), 128))
        ]),
        "row-top-sticky": _withCtx(() => [
          _createVNode(EzCell, {
            style: _normalizeStyle({ gridColumn: `1 / ${_unref(headerList).filter((header) => _unref(vm).displayHeaders.inventoryControl.includes(header)).length + 2}` }),
            class: "table-cell--totalization table-cell--totalization--sticky"
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_5, _toDisplayString(_unref(t)('合計（取引{number}件全ての数値の合計）', { number: String(_unref(state).pagingOptions.totalResultsAvailable) })), 1)
            ], undefined, true),
            _: 1
          }, 8, ["style"]),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(props.transactionMonths, (month) => {
            return (_openBlock(), _createBlock(TransactionSummaryColumn, {
              key: month,
              month: month,
              data: _unref(state).summaryData,
              "header-list": _unref(headerList),
              "inventory-vm": _unref(inventoryVm),
              "monthly-end-header": getMonthlyEndHeader.value[month],
              "order-edit-data": _unref(state).orderEditData,
              "is-order-mode": ""
            }, null, 8, ["month", "data", "header-list", "inventory-vm", "monthly-end-header", "order-edit-data"]))
          }), 128)),
          _createVNode(EzCell, { class: "table-cell--totalization" })
        ]),
        "row-sticky": _withCtx(({ item, virtualItem, handleToggle: rowHandleToggle }) => [
          (virtualItem.type === 'loading')
            ? (_openBlock(), _createBlock(EzCell, {
                key: 0,
                "is-highlighted": "",
                style: { gridColumn: '1 / -1' }
              }, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_6, _toDisplayString(_unref(t)('ローディング中...')), 1)
                ], undefined, true),
                _: 1
              }))
            : (virtualItem.type === 'error')
              ? (_openBlock(), _createBlock(EzCell, {
                  key: 1,
                  class: "table-row--error",
                  style: { gridColumn: '1 / -1' }
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_7, [
                      _createElementVNode("div", _hoisted_8, _toDisplayString(_unref(t)('子情報の取得に失敗しました。再度お試しください。')), 1),
                      _createElementVNode("div", {
                        class: "table-row--error__button",
                        onClick: ($event: any) => (reloadChildBusiness(virtualItem.parentId))
                      }, _toDisplayString(_unref(t)('再取得')), 9, _hoisted_9)
                    ])
                  ], undefined, true),
                  _: 2
                }, 1024))
              : (_openBlock(true), _createElementBlock(_Fragment, { key: 2 }, _renderList(fullHeaders.value, (header, colIdx) => {
                  return (_openBlock(), _createElementBlock(_Fragment, {
                    key: header.key
                  }, [
                    (header.key === 'checkbox')
                      ? (_openBlock(), _createBlock(EzCell, {
                          key: 0,
                          "is-highlighted": isCellHighlighted(virtualItem),
                          "sticky-left": true,
                          "sticky-left-position": getLeftPosition(colIdx)
                        }, {
                          default: _withCtx(() => [
                            _createElementVNode("div", _hoisted_10, [
                              (virtualItem.type === 'parent')
                                ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                                    _withDirectives(_createElementVNode("input", {
                                      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_unref(state).checkedAggregateBusinessIds) = $event)),
                                      type: "checkbox",
                                      value: item.businessId
                                    }, null, 8, _hoisted_12), [
                                      [_vModelCheckbox, _unref(state).checkedAggregateBusinessIds]
                                    ])
                                  ]))
                                : _createCommentVNode("", true),
                              (virtualItem.type === 'parent')
                                ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                                    _createElementVNode("input", {
                                      id: item.businessId,
                                      class: "table-toggle",
                                      type: "checkbox",
                                      onClick: ($event: any) => (rowHandleToggle(item.businessId))
                                    }, null, 8, _hoisted_14),
                                    _createElementVNode("label", {
                                      for: item.businessId,
                                      class: "table-toggle__label"
                                    }, [
                                      (_unref(state).isOpeningBusinessId !== item.businessId)
                                        ? (_openBlock(), _createBlock(SvgLoader, {
                                            key: 0,
                                            class: "table-toggle__label--closed",
                                            name: "chevronRight"
                                          }))
                                        : (_openBlock(), _createBlock(SvgLoader, {
                                            key: 1,
                                            class: "table-toggle__label--opened",
                                            name: "chevronRight"
                                          }))
                                    ], 8, _hoisted_15)
                                  ]))
                                : _createCommentVNode("", true)
                            ])
                          ], undefined, true),
                          _: 2
                        }, 1032, ["is-highlighted", "sticky-left-position"]))
                      : (header.key === 'orderDetail')
                        ? (_openBlock(), _createBlock(EzCell, {
                            key: 1,
                            "is-highlighted": isCellHighlighted(virtualItem),
                            class: "table-cell"
                          }, {
                            default: _withCtx(() => [
                              (virtualItem.type === 'parent')
                                ? (_openBlock(), _createBlock(_component_router_link, {
                                    key: 0,
                                    to: { name: 'recommend-order', params: { id: item.businessId } },
                                    target: "_blank"
                                  }, {
                                    default: _withCtx(() => [
                                      _createVNode(TextButton, {
                                        class: "table-button table-button--detail",
                                        "button-style": "btn-secondary",
                                        "on-click": () => {}
                                      }, {
                                        default: _withCtx(() => [
                                          _createTextVNode(_toDisplayString(_unref(t)('詳細')), 1)
                                        ], undefined, true),
                                        _: 1
                                      })
                                    ], undefined, true),
                                    _: 2
                                  }, 1032, ["to"]))
                                : _createCommentVNode("", true)
                            ], undefined, true),
                            _: 2
                          }, 1032, ["is-highlighted"]))
                        : (header.key === 'memo')
                          ? (_openBlock(), _createBlock(EzCell, {
                              key: 2,
                              "is-highlighted": isCellHighlighted(virtualItem),
                              class: _normalizeClass(virtualItem.type === 'child' ? 'table-memo-cell table-child-item' : 'table-memo-cell')
                            }, {
                              default: _withCtx(() => [
                                (virtualItem.type === 'parent')
                                  ? (_openBlock(), _createBlock(TableMemoButton, {
                                      key: 0,
                                      memo: item.note,
                                      onSave: (memoText) => _unref(saveAggregateMemo)(memoText, item.businessId),
                                      onDelete: () => _unref(deleteAggregateMemo)(item.businessId)
                                    }, null, 8, ["memo", "onSave", "onDelete"]))
                                  : (_openBlock(), _createBlock(TableMemoButton, {
                                      key: 1,
                                      memo: item.note,
                                      onSave: (memoText) => _unref(saveChildMemo)(memoText, item.businessId),
                                      onDelete: () => _unref(deleteChildMemo)(item.businessId)
                                    }, null, 8, ["memo", "onSave", "onDelete"]))
                              ], undefined, true),
                              _: 2
                            }, 1032, ["is-highlighted", "class"]))
                          : (
                _unref(headerList).includes(header.key) &&
                !header.key.startsWith('transaction-') &&
                header.key !== 'orderDetail' &&
                header.key !== 'headerModify'
              )
                            ? (_openBlock(), _createBlock(EzCell, {
                                key: 3,
                                "is-number": _unref(inventoryVm).isNumberHeader(header.key),
                                "is-highlighted": isCellHighlighted(virtualItem),
                                "is-negative": 
                _unref(inventoryVm).isNumberHeader(header.key) &&
                virtualItem.type === 'parent' &&
                _unref(isNegative)(_unref(inventoryVm).getPropertyFromKey(item, header.key, false))
              ,
                                "sticky-left": true,
                                "sticky-left-position": getLeftPosition(colIdx),
                                class: _normalizeClass(
                _unref(inventoryVm).isNumberHeader(header.key)
                  ? _unref(tableNumberStyleClass)(item, _unref(state).isOpeningBusinessId, 'virtualized')
                  : _unref(tableTextStyleClass)(item, _unref(state).isOpeningBusinessId, 'virtualized')
              )
                              }, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(_unref(inventoryVm).getPropertyFromKey(item, header.key, virtualItem.type === 'child') ?? '--'), 1)
                                ], undefined, true),
                                _: 2
                              }, 1032, ["is-number", "is-highlighted", "is-negative", "sticky-left-position", "class"]))
                            : _createCommentVNode("", true)
                  ], 64))
                }), 128))
        ]),
        row: _withCtx(({ item, virtualItem }) => [
          (virtualItem.type === 'loading')
            ? (_openBlock(), _createBlock(EzCell, {
                key: 0,
                "is-highlighted": ""
              }))
            : (virtualItem.type === 'error')
              ? (_openBlock(), _createBlock(EzCell, {
                  key: 1,
                  class: "table-row--error"
                }))
              : (_openBlock(true), _createElementBlock(_Fragment, { key: 2 }, _renderList(fullHeaders.value, (header) => {
                  return (_openBlock(), _createElementBlock(_Fragment, {
                    key: header.key
                  }, [
                    (header.key.startsWith('transaction-') && (virtualItem.type === 'parent' || virtualItem.type === 'child'))
                      ? (_openBlock(), _createBlock(OrderMonthlyColumn, {
                          key: 0,
                          header: header,
                          month: _unref(getMonthFromKey)(header.key),
                          item: item,
                          "virtual-item-type": virtualItem.type,
                          "monthly-data": _unref(state).monthlyData,
                          "order-edit-data": _unref(state).orderEditData,
                          "hidden-transaction-header-list": _unref(state).hiddenTransactionHeaderList,
                          "is-opening-business-id": _unref(state).isOpeningBusinessId,
                          "inventory-vm": _unref(inventoryVm),
                          "table-number-style-class": _unref(tableNumberStyleClass),
                          "is-highlighted": isCellHighlighted(virtualItem),
                          "is-negative": _unref(isNegative),
                          "has-right-border": hasHeaderRightBorder(header.key),
                          "check-nearest-recommend": 
                (monthlyData, businessId, month) => {
                  // 近接推奨チェックロジック（必要に応じて実装）
                  return false;
                }
              ,
                          "get-arrival-status-when-display-button": 
                (monthlyData, businessId, month) => {
                  // 到着ステータス取得ロジック（必要に応じて実装）
                  return _unref(ArrivalStatus).ApprovalRequested;
                }
              ,
                          "ensure-order-data": _unref(ensureOrderData),
                          "find-parent-business-by-id": findParentBusinessById,
                          "confirm-order-edit": 
                (orderRepository, parentBusiness, month) => {
                  _unref(confirmOrderEdit)(orderRepository, parentBusiness, month);
                }
              ,
                          "calc-order-excepted-end": _unref(calcOrderExceptedEnd),
                          "calc-order-turn-over": _unref(calcOrderTurnOver),
                          onUpdateAmount: _cache[2] || (_cache[2] = 
                (businessId, month, amount) => {
                  _unref(ensureOrderData)(_unref(state).orderEditData, businessId, month);
                  _unref(state).orderEditData[businessId][month].amount = amount;
                }
              ),
                          onUpdateDesiredDate: _cache[3] || (_cache[3] = 
                (businessId, month, date) => {
                  _unref(ensureOrderData)(_unref(state).orderEditData, businessId, month);
                  _unref(state).orderEditData[businessId][month].crossDate = date;
                }
              ),
                          onUpdateCalendarFlag: _cache[4] || (_cache[4] = 
                (businessId, month, flag) => {
                  _unref(ensureOrderData)(_unref(state).orderEditData, businessId, month);
                  _unref(state).orderEditData[businessId][month].isEmptyCalendarInputClickedOnce = flag;
                }
              ),
                          onConfirmOrder: _cache[5] || (_cache[5] = 
                (businessId, month) => {
                  _unref(ensureOrderData)(_unref(state).orderEditData, businessId, month);
                  const parentBusiness = findParentBusinessById(businessId);
                  if (parentBusiness) {
                    const orderRepository = new (_unref(OrderRepository))();
                    _unref(confirmOrderEdit)(orderRepository, parentBusiness, month);
                  }
                }
              )
                        }, null, 8, ["header", "month", "item", "virtual-item-type", "monthly-data", "order-edit-data", "hidden-transaction-header-list", "is-opening-business-id", "inventory-vm", "table-number-style-class", "is-highlighted", "is-negative", "has-right-border", "get-arrival-status-when-display-button", "ensure-order-data", "confirm-order-edit", "calc-order-excepted-end", "calc-order-turn-over"]))
                      : (header.key === 'headerModify')
                        ? (_openBlock(), _createBlock(EzCell, {
                            key: 1,
                            "is-highlighted": isCellHighlighted(virtualItem),
                            class: "table-cell"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(BusinessRowMenu, {
                                "is-order-mode": "",
                                "business-id": item.businessId,
                                onSelect: async (e) => _unref(setBusinessRowMenuStateAndProcessing)(e, item, virtualItem.type, virtualItem.parentId)
                              }, null, 8, ["business-id", "onSelect"])
                            ], undefined, true),
                            _: 2
                          }, 1032, ["is-highlighted"]))
                        : _createCommentVNode("", true)
                  ], 64))
                }), 128))
        ]),
        loading: _withCtx(() => [
          _createVNode(EzTableLoadingState, {
            message: _unref(t)('データを読み込んでいます')
          }, null, 8, ["message"])
        ]),
        error: _withCtx(({ retry }) => [
          _createVNode(EzTableErrorState, { onRetry: retry }, null, 8, ["onRetry"])
        ]),
        "zero-match": _withCtx(() => [
          _createVNode(EzTableZeroMatchState)
        ]),
        _: 1
      }, 8, ["id", "items", "item-height", "container-height", "buffer-size", "grid-template-columns", "sticky-column-indexes", "loading-status", "expanded-items"])
    ], 512),
    _createVNode(ForecastAccuracyHistoryModal, {
      "is-open": _unref(state).forecastAccuracyModalState.isOpen,
      "history-data": _unref(state).forecastAccuracyModalState.historyData ?? null,
      "loading-status": _unref(state).forecastAccuracyModalState.loadingState,
      onClose: _unref(closeForecastAccuracyHistoryModal),
      onChangePeriod: _unref(changeForecastAccuracyHistoryPeriod),
      onRetry: _cache[6] || (_cache[6] = 
        () =>
          _unref(state).forecastAccuracyModalState.targetBusinessId &&
          _unref(openForecastAccuracyHistoryModal)(_unref(state).forecastAccuracyModalState.targetBusinessId)
      )
    }, null, 8, ["is-open", "history-data", "loading-status", "onClose", "onChangePeriod"]),
    _createVNode(CombineOrderModal),
    _createVNode(CombineOrderConfirmModal)
  ]))
}
}

})